/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionNotificationType } from './SubscriptionNotificationType';
import {
    SubscriptionNotificationTypeFromJSON,
    SubscriptionNotificationTypeFromJSONTyped,
    SubscriptionNotificationTypeToJSON,
    SubscriptionNotificationTypeToJSONTyped,
} from './SubscriptionNotificationType';
import type { SubscriptionResourceType } from './SubscriptionResourceType';
import {
    SubscriptionResourceTypeFromJSON,
    SubscriptionResourceTypeFromJSONTyped,
    SubscriptionResourceTypeToJSON,
    SubscriptionResourceTypeToJSONTyped,
} from './SubscriptionResourceType';
import type { QueryExpression } from './QueryExpression';
import {
    QueryExpressionFromJSON,
    QueryExpressionFromJSONTyped,
    QueryExpressionToJSON,
    QueryExpressionToJSONTyped,
} from './QueryExpression';
import type { SubscriptionQuotas } from './SubscriptionQuotas';
import {
    SubscriptionQuotasFromJSON,
    SubscriptionQuotasFromJSONTyped,
    SubscriptionQuotasToJSON,
    SubscriptionQuotasToJSONTyped,
} from './SubscriptionQuotas';

/**
 * Request body for creating a new subscription.
 * @export
 * @interface SubscriptionCreateRequest
 */
export interface SubscriptionCreateRequest {
    /**
     * Display name of the subscription.
     * @type {string}
     * @memberof SubscriptionCreateRequest
     */
    name: string;
    /**
     * The memberIdentifier used by the notification engine to read data for this subscription. Default: subscription creator's memberIdentifier.
     * @type {string}
     * @memberof SubscriptionCreateRequest
     */
    memberIdentifier: string;
    /**
     * 
     * @type {SubscriptionNotificationType}
     * @memberof SubscriptionCreateRequest
     */
    notificationType: SubscriptionNotificationType;
    /**
     * 
     * @type {SubscriptionResourceType}
     * @memberof SubscriptionCreateRequest
     */
    resourceType: SubscriptionResourceType;
    /**
     * Internal unique identifier of the resource. Id can have different formats like UUID v4, UUID v7, or any other string calculated.
     * @type {string}
     * @memberof SubscriptionCreateRequest
     */
    resourceId?: string;
    /**
     * 
     * @type {QueryExpression}
     * @memberof SubscriptionCreateRequest
     */
    query?: QueryExpression;
    /**
     * 
     * @type {SubscriptionQuotas}
     * @memberof SubscriptionCreateRequest
     */
    quotas?: SubscriptionQuotas;
}



/**
 * Check if a given object implements the SubscriptionCreateRequest interface.
 */
export function instanceOfSubscriptionCreateRequest(value: object): value is SubscriptionCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('memberIdentifier' in value) || value['memberIdentifier'] === undefined) return false;
    if (!('notificationType' in value) || value['notificationType'] === undefined) return false;
    if (!('resourceType' in value) || value['resourceType'] === undefined) return false;
    return true;
}

export function SubscriptionCreateRequestFromJSON(json: any): SubscriptionCreateRequest {
    return SubscriptionCreateRequestFromJSONTyped(json, false);
}

export function SubscriptionCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'memberIdentifier': json['memberIdentifier'],
        'notificationType': SubscriptionNotificationTypeFromJSON(json['notificationType']),
        'resourceType': SubscriptionResourceTypeFromJSON(json['resourceType']),
        'resourceId': json['resourceId'] == null ? undefined : json['resourceId'],
        'query': json['query'] == null ? undefined : QueryExpressionFromJSON(json['query']),
        'quotas': json['quotas'] == null ? undefined : SubscriptionQuotasFromJSON(json['quotas']),
    };
}

export function SubscriptionCreateRequestToJSON(json: any): SubscriptionCreateRequest {
    return SubscriptionCreateRequestToJSONTyped(json, false);
}

export function SubscriptionCreateRequestToJSONTyped(value?: SubscriptionCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'memberIdentifier': value['memberIdentifier'],
        'notificationType': SubscriptionNotificationTypeToJSON(value['notificationType']),
        'resourceType': SubscriptionResourceTypeToJSON(value['resourceType']),
        'resourceId': value['resourceId'],
        'query': QueryExpressionToJSON(value['query']),
        'quotas': SubscriptionQuotasToJSON(value['quotas']),
    };
}

